"use client";
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { Component } from "react";
import { merge } from "lodash";
import { ThemeProvider } from "styled-components";
class ThemePartialProvider extends Component {
    static calculateTheme(props) {
        const { dark, otherTheme = {}, theme = {} } = props;
        const { colors: themeColors, colorsVariationsFactory, componentsFactory, darkComponentsFactory, globals } = theme;
        const { components: otherComponents = {}, colors: otherColors = {} } = otherTheme, otherRest = _object_without_properties_loose(otherTheme, [
            "components",
            "colors"
        ]);
        const baseColors = merge({}, themeColors, otherColors);
        const colors = !!colorsVariationsFactory ? colorsVariationsFactory({
            colors: baseColors
        }) : {};
        let components = {};
        const componentsArgs = {
            colors,
            globals
        };
        if (dark) {
            components = !!darkComponentsFactory ? merge({}, components, darkComponentsFactory(componentsArgs)) : {};
        } else {
            components = !!componentsFactory ? componentsFactory(componentsArgs) : {};
        }
        return merge({}, theme || {}, otherRest || {}, {
            colors
        }, {
            components: merge({}, components, otherComponents)
        });
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { dark, light, otherTheme, theme } = nextProps;
        if (light !== prevState.light || dark !== prevState.dark || otherTheme !== prevState.otherTheme || theme !== prevState.theme) {
            return {
                dark,
                light,
                otherTheme,
                theme: ThemePartialProvider.calculateTheme(nextProps)
            };
        }
        return null;
    }
    render() {
        const { children, theme: propTheme } = this.props;
        const { theme } = this.state;
        const realTheme = theme || propTheme;
        return /*#__PURE__*/ React.createElement(ThemeProvider, {
            theme: realTheme
        }, children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            theme: ThemePartialProvider.calculateTheme(this.props)
        };
    }
}
export default ThemePartialProvider;
